import { Button, Table, Header, Cell, Body, Row, showToast } from "@jobber/components";
import CreateTimeOffModal from "@/components/CreateTimeOffModal";
import { trpc } from "@/services/trpc";
import { useRef } from "react";
import { formatDate } from "@/utils";
import ConfirmationDialog from "@/components/ConfirmationDialog"
import type { RefFields as CreateTimeOffModalRefFields, TimeOffFormResult } from "@/components/CreateTimeOffModal";
import type { RefFields as ConfirmRefFields } from "@/components/ConfirmationDialog"

export default function TimeOffsSettingsTab() {

  const timeOffsListQuery = trpc.timeOffs.list.useQuery()
  const timeOffsCreateMutation = trpc.timeOffs.create.useMutation()
  const timeOffsUpdateMutation = trpc.timeOffs.update.useMutation()
  const timeOffsDeleteMutation = trpc.timeOffs.delete.useMutation()

  const createTimeOffModalRef = useRef<CreateTimeOffModalRefFields>(null)
  const confirmationDialogRef = useRef<ConfirmRefFields>(null)

  const onTimeWindowFormSubmit = async (formData: TimeOffFormResult) => {
    if (formData.id === undefined || formData.id === null) {
      timeOffsCreateMutation.mutate(formData, {
        onSuccess: () => {
          showToast({
            message: 'Time off successfully created',
            variation: 'success',
          })
          timeOffsListQuery.refetch()
        }
      })
    } else {
      timeOffsUpdateMutation.mutate({id: formData.id, data: formData}, {
        onSuccess: () => {
          showToast({
            message: 'Time off successfully updated',
            variation: 'success',
          })
          timeOffsListQuery.refetch()
        }
      })
    }
  }
  const onCreateClick = () => {
    createTimeOffModalRef?.current?.openModal()
  }
  const onTimeWindowEditClick = (id: string) => {
    createTimeOffModalRef?.current?.openModal(timeOffsListQuery.data?.find((tw: any) => tw.id === id))
  }
  const onTimeWindowDelete = async (id: string) => {
    const res = await confirmationDialogRef.current?.open({
      title: `Delete time off ${timeOffsListQuery.data?.find((tw: any) => tw.id === id)?.reason}`,
      message: 'Are you sure you want to delete this time off?'
    })
    if (res) {
      timeOffsDeleteMutation.mutate(id, {
        onSuccess: () => {
          showToast({
            message: 'Time off successfully deleted',
            variation: 'success',
          })
          timeOffsListQuery.refetch()
        }
      })
    }
  }
  return (
    <div style={{marginTop: '20px'}}>
      <div
        style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '1.5em', fontWeight: 'bold', marginBottom: '10px' }}
      >
        <div>
          Time offs
        </div>
        <Button label="Add new" icon={'plus'} onClick={onCreateClick}/>
      </div>
      {timeOffsListQuery.data?.length ? (<Table>
        <Header>
          <Cell>Name</Cell>
          <Cell>Service Area</Cell>
          <Cell>Start time</Cell>
          <Cell>End time</Cell>
          <Cell align="right"></Cell>
        </Header>
        <Body>
          { timeOffsListQuery.data?.map((tw: any, index: number) => (
            <Row key={index}>
              <Cell>{ tw.reason }</Cell>
              <Cell>{tw.serviceArea?.name}</Cell>
              <Cell>{formatDate(tw.start)}</Cell>
              <Cell>{formatDate(tw.end)}</Cell>
              <Cell>
                <div style={{ display: "flex", justifyContent: "end" }}>
                  <Button
                    type="tertiary"
                    variation="destructive"
                    ariaLabel="delete"
                    icon="trash"
                    onClick={() => onTimeWindowDelete(tw.id)}
                  />
                  <Button
                    type="tertiary"
                    variation="subtle"
                    ariaLabel="delete"
                    icon="edit"
                    onClick={() => onTimeWindowEditClick(tw.id)}
                  />
              </div>
            </Cell>
          </Row>
          ))}
        </Body>
      </Table>) : (<div style={{textAlign: 'center'}}>Time offs not found</div>)}
      <CreateTimeOffModal ref={createTimeOffModalRef} onSubmit={onTimeWindowFormSubmit} />
      <ConfirmationDialog ref={confirmationDialogRef} />
    </div>
  )
}
